import { Component, inject, OnInit, viewChild, ViewContainerRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InternationalizationService } from '@core/internationalization/internationalization.service';
import { CustomPortalService } from '@core/services/custom-portal.service';
import { AuthService } from '@features/auth/auth.service';
import { TwxToasterComponent } from '@twinnyx/shared/toast/twx-toaster.component';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet />
        <ng-template #project />
        <twx-toaster />
    `,
    imports: [RouterOutlet, TwxToasterComponent],
})
export class AppComponent implements OnInit {
    private readonly authService = inject(AuthService);
    private readonly customPortalS = inject(CustomPortalService);
    private readonly internationalizationS = inject(InternationalizationService);

    protected readonly portalContainer = viewChild.required('project', {
        read: ViewContainerRef,
    });

    ngOnInit() {
        this.internationalizationS.init();
        this.customPortalS.init(this.portalContainer());

        this.authService.checkIsLoggedIn();
    }
}
